import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, Button, InputLabel, Typography, FormGroup } from "@mui/material";
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Paper from "@mui/material/Paper";
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

const LastChangesDetails = ({
    last_changes
}) => {
    const changes = last_changes ? last_changes.split("~") : [];

    // Map the change strings to an array of objects
    const changesArray = changes
        .filter((item) => item !== "")
        .map((item) => ({
            field: item.split(";")[0],
            oldValue: item.split(";")[1],
            newValue: item.split(";")[2],
            date: item.split(";")[3],
        }));

    // Group the changes by date using the reduce method
    const changesByDate = changesArray.reduce((changes, change) => {
        const date = change.date;
        if (date in changes) {
            changes[date].push(change);
        } else {
            changes[date] = [change];
        }
        return changes;
    }, {});

    // Extract the dates and changes from the changesByDate object
    const dates = Object.keys(changesByDate);
    const groupedChanges = Object.values(changesByDate);

    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
                <Grid item xs={12}>
                    {/* Use the dates and groupedChanges arrays to render the changes by date */}
                    {dates.map((date, index) => (
                        <div key={date}>
                            <Typography fontWeight={"bold"}>{date}</Typography>
                            <List dense>
                                {groupedChanges[index].map((change) => (
                                    <ListItem key={Math.random()}>
                                        <ListItemText
                                            primary={change.field}
                                            secondary={`[${change.oldValue}] -> [${change.newValue}]`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    ))}
                </Grid>
            </Grid>
        </Paper>
    )
}

export default LastChangesDetails